import moment from 'moment'
import React from 'react'

//* utils
import { ModuleNames } from '../../../../../../constants/componentNames.constants'
import { OPTIONS } from '../../../../../../constants/dateOptions'

//* components
import ContentBlock from '../../../../../global/contentBlock'
import ContentColumns from '../../../../../global/contentColumns'
import Hero from '../../../../../global/hero'
import MainCTA from '../../../../../global/mainCta'
import Tiles from '../../../../../global/tiles'
import ListingItem from '../../listingItem'

export const getFeaturedListing = (
  featuredListings: any,
  locale: string,
  listingIDsToExlude: any,
  LISTING_TYPES: any
) => {
  return (
    featuredListings.map((listing: any, index: number) => {
      const listingData = {
        title: listing.title || listing.h1Title || '',
        date: listing.date || '',
        slug: listing.slug || '',
        url: listing.url1 || '',
        type: listing.articleType || LISTING_TYPES.MEDIA_COVERAGE,
        publication: (listing.metaInformation && listing.metaInformation[0]?.customerName) || '',
      }

      let formattedDate = ''
      const date = new Date(listingData.date)
      if (date) formattedDate = moment(date).utc().format('MMMM DD, YYYY')
      formattedDate = new Date(formattedDate).toLocaleDateString(locale, OPTIONS)
      listingIDsToExlude.add(listing.id)

      return (
        <ListingItem
          key={`FeaturedListItem--${listingData.slug}-${index}`}
          {...{
            listingTitle: listingData.title,
            listingSlug: listingData.slug,
            listingUrl: listingData.url,
            listingType: listingData.type,
            listingPublication: listingData.publication,
            formattedDate,
          }}
        />
      )
    }) || []
  )
}

export const getModules = (listingPageData: any, pageContent: any, location: any) =>
  listingPageData.flexSection.map((module: any, i: Number) => {
    switch (module.__typename) {
      case ModuleNames.GLOBAL_CONTENT_BLOCK:
        return <ContentBlock data={module} key={`page-component--${i}`} />

      case ModuleNames.ANCHOR_LINK:
        const identifier = module?.identifier || ''
        return <span id={identifier}></span>

      case ModuleNames.HERO:
        pageContent.hero = (
          <Hero
            data={module}
            location={location}
            pageTitle={listingPageData.name}
            showBreadcrumbs={true}
            key={`page-component--${i}`}
            pageType="companyListing"
            metaInformation={listingPageData.metaInformation}
            pageUseCase={listingPageData.useCase}
            locale={pageContent.locale}
            breadcrumb={module.breadcrumb || listingPageData.breadcrumb}
          />
        )
        return null
      case ModuleNames.GLOBAL_MAIN_CTA:
        return <MainCTA data={module} key={`page-component--${i}`} />

      case ModuleNames.TILES:
        return <Tiles data={module} key={`page-component--${i}`} />

      case ModuleNames.GLOBAL_CONTENT_COLUMNS:
        return (
          <ContentColumns data={module} pageType="companyListing" key={`page-component--${i}`} />
        )
    }
  }) || []
